import {Controller} from "../controller";
import traduccion from "i18n";
import site from "../data/site";
import {Langs} from "i18n/langs";

export class LandingB2C extends Controller {

    /* INSTANCE */
    public static override async build(): Promise<void> {
        let modulos:any = document.getElementsByClassName("download-app") as any;
        const translate = await traduccion(site.lang.idioma as Langs, site.lang.defecto).then(modulos=>modulos.footer).then(modulos=>modulos.link_apps);

        let userAgent = navigator.userAgent || navigator.vendor;
        let android = /android/i.test(userAgent);
        let ios = /iphone|ipod|ipad/i.test(userAgent);
        let huawei = /huawei/i.test(userAgent);
        let otros = !(android || ios || huawei);

        if (android || ios || huawei || otros) {
            let enlaceApp: string = '';
            let enlaceAppPro: string = '';
            let title: string = '';

            if (android || huawei || otros) {
                enlaceApp = huawei ? translate.url_huawei : translate.url_android;
                enlaceAppPro = huawei ? translate.url_huawei : translate.url_android_pro;
                title = huawei ? translate.download_huawei : translate.download_android;

            } else if (ios) {
                enlaceApp = translate.url_ios;
                enlaceAppPro = translate.url_ios_pro;
                title = translate.download_ios;
            }

            for (let modulo of modulos) {
                modulo.href = modulo.classList.contains('pro') ? decodeURIComponent(enlaceAppPro) : decodeURIComponent(enlaceApp);
                modulo.title = title;
                modulo.target = "blank";
            }
        }

        //Manejo de los enlaces de paises
        const countries_ul:HTMLElement = <HTMLElement>document.getElementsByClassName("countries").item(0);
        const countries = countries_ul.getElementsByTagName("li");

        for (let i = 0; i < countries.length; i++) {
            const li = countries[i] as HTMLLIElement;

            li.addEventListener("click", () => {
                const link = li.getElementsByTagName("a")[0] as HTMLAnchorElement;
                if (link) {
                    window.open(link.href, "_blank");
                }
            });
        }
    }
}



